/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  //console.log('custom.js loaded');

  const lenis = new Lenis({ 
    lerp: 0.1,
    //syncTouch: true,
    //touchInertiaMultiplier: 2,
  });

/*   lenis.on('scroll', (e) => {
    console.log(e);
  }); */

  // This function is crucial for Lenis to work - it updates the scroll animation
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  // Start the animation loop
  requestAnimationFrame(raf);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
